import React from "react";
import { Dialog, DialogContent, Box, Typography, Button, useMediaQuery } from "@mui/material";
import theme from "../../util/theme/theme";

export interface ProvisionTaxScopePopupProps {
    open: boolean;
    onCancel: () => void;
    onThisOccurrence: () => void;
    onAllOccurrences: () => void;
}

// Changing the applied taxes on one occurrence of a recurring provision -
// apply it to every occurrence (the provision itself), or only this one.
const ProvisionTaxScopePopup: React.FC<ProvisionTaxScopePopupProps> = ({ open, onCancel, onThisOccurrence, onAllOccurrences }) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    let contentStyle = { p: 0, pt: 3, pb: 3, px: 4, textAlign: 'center', minWidth: 340 };
    if (isMobile) contentStyle = { p: 2, pt: 3, pb: 3, px: 2, textAlign: 'center', minWidth: 200 };

    return (
        <Dialog open={open} onClose={onCancel} maxWidth="xs" PaperProps={{ sx: { borderRadius: isMobile ? 2 : 4, p: 0, overflow: 'hidden' } }}>
            <DialogContent sx={contentStyle}>
                <Typography variant="h6" fontWeight={700} mb={1.5}>
                    Change Applied Taxes?
                </Typography>
                <Typography color="text.secondary" fontSize={14} mb={3}>
                    Apply this to every occurrence of this recurring provision, or only this one?
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
                    <Button
                        variant="contained"
                        fullWidth
                        onClick={onAllOccurrences}
                        sx={{ borderRadius: 2, fontWeight: 600, py: 1.1, boxShadow: 'none', textTransform: 'none', background: 'var(--color-primary)', color: '#fff', '&:hover': { background: 'var(--color-primary)' } }}
                    >
                        All Occurrences
                    </Button>
                    <Button
                        variant="outlined"
                        fullWidth
                        onClick={onThisOccurrence}
                        sx={{ borderRadius: 2, fontWeight: 600, py: 1.1, textTransform: 'none' }}
                    >
                        This Occurrence Only
                    </Button>
                    <Button
                        variant="text"
                        fullWidth
                        onClick={onCancel}
                        sx={{ borderRadius: 2, fontWeight: 600, py: 1.1, textTransform: 'none', color: 'var(--color-text-muted)' }}
                    >
                        Cancel
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default ProvisionTaxScopePopup;
